<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <!-- Header Padrao -->
      <HeaderPadrao class="mb-2" icon="fa fa-undo" titulo="CADASTRO DE DEVOLUÇÃO">
        <template #subtitulo>
          <span v-if="devolucao.ID">
            <i class="fa fa-tag mr-1 text-info"></i>
            ID: <strong class="text-white">{{ devolucao.ID }}</strong>
            <span class="mx-2">•</span>
          </span>
          <i class="fa fa-user mr-1 text-info"></i>
          Cliente: <strong class="text-white">{{ devolucao.FORNECEDOR_ID }} - {{ devolucao.CLIENTE_NOME || 'Selecione a Venda' }}</strong>
          <span v-if="devolucao.VENDA_ID" class="mx-2">•</span>
          <span v-if="devolucao.VENDA_ID">
            <i class="fa fa-shopping-cart mr-1 text-info"></i>
            Venda Origem: <strong class="text-white">{{ devolucao.VENDA_ID }}</strong>
          </span>
        </template>

        <template #acoes>
          <b-button v-if="!devolucao.VENDA_ID" variant="link" class="btn-glass btn-glass-success" v-b-modal="'modal-pesquisa-vendas-devolucao'">
            <i class="fa fa-link mr-1"></i> Vincular Pré-fatura
          </b-button>

          <b-button v-if="devolucao.ID" variant="link" class="btn-glass btn-glass-info" @click="vincularXml" :disabled="edicaoDadosBloqueada">
            <i class="fa fa-file-code-o mr-1"></i> Vincular XML
          </b-button>

          <b-button v-if="podeGravar" variant="link" class="btn-glass btn-glass-primary" @click="salvar()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button v-if="podeSolicitarConferencia" variant="link" class="btn-glass btn-glass-warning" @click="solicitarConferencia()">
            <i class="fa fa-clipboard mr-1"></i> SOLICITAR CONFERENCIA
          </b-button>

          <b-button v-if="podeCancelarSolicitacaoConferencia" variant="link" class="btn-glass btn-glass-warning" @click="cancelarSolicitacaoConferencia()">
            <i class="fa fa-ban mr-1"></i> CANCELAR CONFERENCIA
          </b-button>

          <b-button v-if="podeDevolverTerminal" variant="link" class="btn-glass btn-glass-warning" @click="devolverTerminalConferencia()">
            <i class="fa fa-reply mr-1"></i> DEVOLVER AO TERMINAL
          </b-button>

          <b-button v-if="podeConcluir" variant="link" class="btn-glass btn-glass-success" @click="concluir()">
            <i class="fa fa-check-circle mr-1"></i> CONCLUIR
          </b-button>

          <b-button v-if="podeCancelarDevolucao" variant="link" class="btn-glass btn-glass-danger" @click="cancelarDevolucao()">
            <i class="fa fa-trash-o mr-1"></i> CANCELAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </HeaderPadrao>

      <!-- Summary Bar -->
      <b-row class="mb-3 px-1" v-if="devolucao.VENDA_ID">
        <b-col md="3">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center border-top border-info" style="border-top-width: 3px !important;">
            <small class="text-muted d-block uppercase font-weight-bold">Valor Venda</small>
            <h4 class="mb-0 font-weight-bold text-dark">{{ formatarMoeda(devolucao.VALOR_VENDA) }}</h4>
          </div>
        </b-col>
        <b-col md="3">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center border-top border-primary" style="border-top-width: 3px !important;">
            <small class="text-muted d-block uppercase font-weight-bold">Valor Devolvido</small>
            <h4 class="mb-0 font-weight-bold text-primary">{{ formatarMoeda(devolucao.VALOR_DEVOLUCAO_NFE) }}</h4>
          </div>
        </b-col>
        <b-col md="3">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center border-top border-warning" style="border-top-width: 3px !important;">
            <small class="text-muted d-block uppercase font-weight-bold">Recalculado</small>
            <h4 class="mb-0 font-weight-bold text-warning">{{ formatarMoeda(devolucao.VALOR_REPROCESSADO) }}</h4>
          </div>
        </b-col>
        <b-col md="3">
          <div class="stat-item bg-dark p-3 rounded shadow-sm text-center text-white border-0 h-100 d-flex flex-column justify-content-center" style="background: linear-gradient(135deg, #4b6cb7 0%, #182848 100%) !important;">
            <small class="text-white-50 d-block uppercase font-weight-bold">Saldo a Conciliar</small>
            <h4 class="mb-0 font-weight-bold">{{ formatarMoeda(saldoConciliar) }}</h4>
          </div>
        </b-col>
      </b-row>

      <!-- Configuration Bar -->
      <div class="mb-4 px-1" v-if="devolucao.VENDA_ID">
        <div class="card border-0 shadow-xs bg-soft-primary p-3 rounded-lg border-left border-primary" style="border-left-width: 5px !important;">
          <b-row align-v="center">
            <b-col md="3">
              <label class="text-primary font-weight-bold mb-1 d-block"><i class="fa fa-file-text-o mr-2"></i>Tipo fiscal da NF-e propria</label>
              <TipoMovimentacaoDropDown
                v-model="tipoMovimentacaoNfeId"
                :disabled="tipoMovimentacaoNfeBloqueado"
                placeholder="Selecione o tipo de movimentação..."
                class="shadow-sm"
              />
              <small class="text-muted mt-1 d-block font-italic">Utilizado para emissão da NF-e própria e regras fiscais.</small>
            </b-col>
            <b-col md="3">
              <label class="text-primary font-weight-bold mb-1 d-block"><i class="fa fa-address-card-o mr-2"></i>Destinatario da NF-e propria</label>
              <ClientePesquisa
                :idInicial="devolucao.DESTINATARIO_ID"
                :desabilitarInput="tipoMovimentacaoNfeBloqueado"
                idModal="modal-destinatario-devolucao"
                place="Selecione o destinatario..."
                @retornaId="onDestinatarioChange"
              />
              <small class="text-muted mt-1 d-block font-italic">Cadastro usado como destinatario/remetente da NF-e propria.</small>
            </b-col>
            <b-col md="3">
              <label class="text-primary font-weight-bold mb-1 d-block"><i class="fa fa-archive mr-2"></i>Centro de Estoque</label>
              <CentroEstoqueDropDown
                v-model="devolucao.CENTRO_ESTOQUE_ID"
                :disabled="centroEstoqueBloqueado"
                @change="onCentroEstoqueChange"
                placeholder="Selecione o centro de estoque..."
                class="shadow-sm"
              />
              <small class="text-muted mt-1 d-block font-italic">Obrigatorio para devolver as etiquetas ao estoque na conclusao.</small>
            </b-col>
            <b-col md="3">
              <div class="alert alert-light border-0 mb-0 shadow-none py-2 px-3 small text-muted bg-white-50 rounded">
                <i class="fa fa-info-circle text-primary mr-2"></i>
                A conclusao atualiza pre-fatura, financeiro e devolve fisicamente as etiquetas para o centro selecionado.
              </div>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="mb-4 px-1" v-if="devolucao.ID">
        <div class="flow-board shadow-xs">
          <div
            v-for="etapa in fluxoBadges"
            :key="etapa.key"
            class="flow-step"
            :class="`flow-step--${etapa.variant}`"
          >
            <div class="flow-step__icon">
              <i :class="etapa.icon"></i>
            </div>
            <div class="flow-step__body d-flex flex-column justify-content-between">
              <div>
                <div class="flow-step__top">
                  <strong>{{ etapa.titulo }}</strong>
                  <b-badge :variant="etapa.variant" pill>{{ etapa.status }}</b-badge>
                </div>
                <small>{{ etapa.descricao }}</small>
              </div>
              
              <!-- Metrics inside Conferencia card -->
              <div v-if="etapa.key === 'conferencia'" class="flow-step__metrics">
                <span>Previstos: <strong>{{ formatarQuantidade(totalVolumesDevolucao, 0) }}</strong></span>
                <span>Coletados: <strong>{{ totalEtiquetasColetadas }}</strong></span>
                <span>Conferido: <strong>{{ formatarQuantidade(totalPesoConferido, 3) }} kg</strong></span>
              </div>
              <div v-if="etapa.key === 'nfe' && nfePropriaAutorizada" class="flow-step__actions">
                <b-button size="sm" variant="outline-primary" class="px-3" @click.stop="imprimirDanfeDevolucao">
                  <i class="fa fa-print mr-1"></i> Ver DANFE
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="card border-0 shadow-sm rounded-lg overflow-hidden">
        <b-tabs content-class="p-4" nav-class="bg-light border-bottom-0 custom-tabs-premium" active-nav-item-class="bg-white font-weight-bold text-primary border-bottom-0">
          
          <!-- Aba Produtos -->
          <b-tab title="Produtos e Itens" active>
            <template #title>
              <i class="fa fa-cube mr-2"></i> Produtos e Itens
            </template>

            <div v-if="!devolucao.VENDA_ID" class="text-center p-5 bg-light rounded border border-dashed">
              <i class="fa fa-link fa-4x text-muted mb-3"></i>
              <h4>Vincule uma Pré-fatura para listar os itens</h4>
              <p class="text-muted">Use o botão "Vincular Pré-fatura" no topo da página.</p>
              <b-button variant="primary" pill class="px-4 mt-2" v-b-modal="'modal-pesquisa-vendas-devolucao'">
                LOCALIZAR AGORA
              </b-button>
              <b-button v-if="devolucao.ID" variant="outline-info" pill class="px-4 mt-2 ml-2" @click="vincularXml">
                VINCULAR XML
              </b-button>
            </div>

            <div v-else>
              <div v-if="edicaoDadosBloqueada" class="alert alert-warning border-0 shadow-xs mb-3">
                <i class="fa fa-lock mr-2"></i>
                Os dados da devolucao ficam bloqueados apos solicitar/coletar conferencia. Para corrigir etiquetas, use <strong>Devolver ao Terminal</strong>.
              </div>
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="font-weight-bold text-dark mb-0">Itens da Venda Original x Devolução</h6>
                <b-badge variant="soft-info" pill class="px-3 py-2">ITENS CARREGADOS DA VENDA #{{ devolucao.VENDA_ID }}</b-badge>
              </div>

              <b-table
                hover
                small
                responsive
                :items="devolucao.itens"
                :fields="itemFields"
                class="modern-premium-table"
              >
                <template #cell(QUANT)="data">
                   <div class="d-flex align-items-center justify-content-end">
                      <span class="text-muted mr-2">{{ formatarQuantidade(data.value, 3) }}</span>
                      <i class="fa fa-arrow-right text-info small mr-2"></i>
                      <vue-autonumeric 
                        v-model="data.item.QUANT_DEVOLVIDO_NFE" 
                        :options="formatoQuantidade"
                        :disabled="edicaoDadosBloqueada"
                        class="form-control form-control-sm text-right font-weight-bold border-primary shadow-xs" 
                        style="width: 100px"
                      />
                   </div>
                </template>

                <template #cell(PECAS)="data">
                   <div class="d-flex align-items-center justify-content-end">
                      <span class="text-muted mr-2">{{ data.value }}</span>
                      <i class="fa fa-arrow-right text-info small mr-2"></i>
                      <vue-autonumeric 
                        v-model="data.item.PECAS_DEVOLVIDO_NFE" 
                        :options="formatoPecas"
                        :disabled="edicaoDadosBloqueada"
                        class="form-control form-control-sm text-right font-weight-bold border-primary shadow-xs" 
                        style="width: 80px"
                      />
                   </div>
                </template>

                <template #cell(VL_UNT)="data">
                   <div class="d-flex align-items-center justify-content-end">
                      <span class="text-muted mr-2">{{ formatarMoeda(data.value) }}</span>
                      <i class="fa fa-arrow-right text-info small mr-2"></i>
                      <vue-autonumeric 
                        v-model="data.item.VL_UNT_DEVOLVIDO" 
                        :options="formatoMoeda"
                        :disabled="edicaoDadosBloqueada"
                        class="form-control form-control-sm text-right font-weight-bold border-primary shadow-xs" 
                        style="width: 120px"
                      />
                   </div>
                </template>

                <template #cell(TOTAL_ITEM)="data">
                  <span class="font-weight-bold" :class="data.item.QUANT_DEVOLVIDO_NFE > 0 ? 'text-success' : 'text-muted'">
                    {{ formatarMoeda(data.item.QUANT_DEVOLVIDO_NFE * (data.item.VL_UNT_DEVOLVIDO || data.item.VL_UNT)) }}
                  </span>
                </template>
              </b-table>

              <div v-if="etiquetasColetadas.length" class="mt-4">
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h6 class="font-weight-bold text-dark mb-0">
                    <i class="fa fa-barcode mr-2 text-primary"></i>Etiquetas coletadas na devolucao
                  </h6>
                  <b-badge variant="success" pill class="px-3 py-2">{{ etiquetasColetadas.length }} etiqueta(s)</b-badge>
                </div>
                <b-table
                  hover
                  small
                  responsive
                  :items="etiquetasColetadas"
                  :fields="etiquetaColetadaFields"
                  class="modern-premium-table mb-0"
                >
                  <template #cell(SEQUENCIA_EMBARQUE)="data">
                    <span class="font-weight-bold">#{{ data.value || '-' }}</span>
                  </template>
                  <template #cell(CODIGO_BARRAS)="data">
                    <div class="font-weight-bold">{{ data.value }}</div>
                    <small class="text-muted">{{ data.item.DESCRICAO }}</small>
                  </template>
                  <template #cell(PESO)="data">
                    {{ formatarQuantidade(data.value, 3) }}
                  </template>
                  <template #cell(PECAS)="data">
                    {{ formatarQuantidade(data.value, 0) }}
                  </template>
                  <template #cell(DATA_MOVIMENTO)="data">
                    {{ data.value ? formatarData(data.value) : '-' }}
                  </template>
                </b-table>
              </div>
            </div>
          </b-tab>

          <!-- Aba XML / SEFAZ -->
          <b-tab title="XML NFe / SEFAZ">
            <template #title>
              <i class="fa fa-file-code-o mr-2"></i> XML NFe / SEFAZ
            </template>
            
            <b-row>
              <b-col md="6">
                <div class="p-4 bg-light rounded border h-100">
                  <h6 class="font-weight-bold mb-4"><i class="fa fa-cloud-download mr-2 text-primary"></i>Gestão de XML via SEFAZ</h6>
                  
                  <div class="mb-3">
                    <label class="small font-weight-bold text-muted">Chave de Acesso da NFe Devolvida</label>
                    <b-input-group>
                      <b-form-input v-model="devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA" placeholder="44 dígitos da chave de acesso" />
                      <b-input-group-append>
                        <b-button variant="info" @click="consultarSefaz()"><i class="fa fa-search"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>

                  <div class="d-flex gap-2">
                    <b-button variant="outline-warning" @click="darCienciaSefaz()" :disabled="!devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA">
                      <i class="fa fa-bell-o mr-1"></i> Dar Ciencia
                    </b-button>
                    <b-button variant="outline-primary" @click="manifestarSefaz()" :disabled="!devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA">
                      <i class="fa fa-check-circle mr-1"></i> Manifestar Confirmação
                    </b-button>
                    <b-button variant="outline-success" @click="baixarXmlSefaz()" :disabled="!devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA">
                      <i class="fa fa-download mr-1"></i> Baixar XML (DFe)
                    </b-button>
                    <b-button v-if="devolucao.OP_XML === '1'" variant="outline-danger" @click="desvincularXml()" :disabled="!devolucao.ID">
                      <i class="fa fa-unlink mr-1"></i> Desvincular
                    </b-button>
                  </div>

                  <hr class="my-4">

                  <div v-if="devolucao.OP_CONFIRMAR_NFE === '1'" class="alert alert-success border-0 shadow-xs mb-0">
                    <i class="fa fa-check-circle mr-2"></i> Nota Fiscal manifestada com sucesso junto à SEFAZ.
                  </div>
                  <div v-else class="alert alert-warning border-0 shadow-xs mb-0">
                    <i class="fa fa-info-circle mr-2"></i> NFe pendente de manifestação ou consulta.
                  </div>
                </div>
              </b-col>

              <b-col md="6">
                <div class="p-4 bg-white rounded border h-100">
                  <h6 class="font-weight-bold mb-4"><i class="fa fa-exchange mr-2 text-success"></i>Conciliação de Itens XML</h6>
                  <p class="text-muted small">Vincule um arquivo XML local ou baixado da SEFAZ para conciliar as quantidades e valores automaticamente.</p>
                  
                  <div class="text-center py-4 border-2 border-dashed rounded bg-light">
                    <i class="fa fa-file-excel-o fa-3x text-muted mb-2"></i>
                    <p class="mb-0">XML Vinculado: <strong>{{ devolucao.XML_NOME || 'Nenhum' }}</strong></p>
                    <b-button variant="soft-success" pill class="mt-3 px-4 font-weight-bold" @click="vincularXml()">
                      VINCULAR E CONCILIAR XML
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>

          <!-- Aba Decisao Fiscal -->
          <b-tab title="Decisao Fiscal">
            <template #title>
              <i class="fa fa-balance-scale mr-2"></i> Decisao Fiscal
            </template>

            <div v-if="!devolucao.ID" class="text-center p-5 bg-light rounded border border-dashed">
              <i class="fa fa-balance-scale fa-4x text-muted mb-3"></i>
              <h4>Abra uma devolucao para validar a decisao fiscal</h4>
            </div>

            <div v-else>
              <!-- Informações das Notas Fiscais (Referência e Própria) -->
              <b-row class="mb-4 px-1">
                <b-col md="6">
                  <div class="card border-0 shadow-sm p-3 rounded-lg bg-light h-100 border-left border-info" style="border-left-width: 4px !important;">
                    <small class="text-muted d-block uppercase font-weight-bold mb-2">
                      <i class="fa fa-shopping-cart text-info mr-2"></i>NF-e de Origem (Venda)
                    </small>
                    <div v-if="decisaoFiscal && decisaoFiscal.nfeOriginal">
                      <div class="mb-1">Número: <strong class="text-dark">{{ decisaoFiscal.nfeOriginal.TX_NUM_NFE }}</strong></div>
                      <div>Chave: <small class="text-muted font-italic">{{ formatarChaveAcesso(decisaoFiscal.nfeOriginal.TX_CHAVE_ACESSO) }}</small></div>
                    </div>
                    <div v-else class="text-muted small italic">
                      Nenhuma NF-e de origem localizada para a venda #{{ devolucao.VENDA_ID }}.
                    </div>
                  </div>
                </b-col>
                <b-col md="6">
                  <div class="card border-0 shadow-sm p-3 rounded-lg bg-light h-100 border-left border-warning" style="border-left-width: 4px !important;">
                    <small class="text-muted d-block uppercase font-weight-bold mb-2">
                      <i class="fa fa-file-text-o text-warning mr-2"></i>NF-e de Devolução (Própria)
                    </small>
                    <div v-if="devolucao.NFE_DEVOLUCAO_ID">
                      <div class="mb-1">
                        Número: <strong class="text-dark">{{ devolucao.NFE_DEVOLUCAO_NUMERO || 'Gerando/Rascunho' }}</strong> 
                        <b-badge class="ml-2" :variant="nfePropriaAutorizada ? 'success' : 'warning'">
                          {{ nfePropriaAutorizada ? 'Autorizada' : 'Pendente' }}
                        </b-badge>
                        <b-button
                          v-if="nfePropriaAutorizada"
                          size="sm"
                          variant="outline-primary"
                          class="ml-2 py-0 px-2"
                          @click.stop="imprimirDanfeDevolucao"
                        >
                          <i class="fa fa-print mr-1"></i>DANFE
                        </b-button>
                      </div>
                      <div>Chave: <small class="text-muted font-italic">{{ formatarChaveAcesso(devolucao.NFE_DEVOLUCAO_CHAVE_ACESSO) }}</small></div>
                    </div>
                    <div v-else class="text-muted small italic">
                      Nenhuma NF-e própria de devolução gerada ainda.
                    </div>
                  </div>
                </b-col>
              </b-row>

              <div class="d-flex justify-content-between align-items-center mb-3 mt-4">
                <h6 class="font-weight-bold text-dark mb-0">NF-e declarada x conferencia fisica</h6>
                <div class="d-flex align-items-end flex-wrap justify-content-end">
                  <b-button variant="outline-primary" size="sm" class="mr-2" @click="carregarDecisaoFiscal()" :disabled="decisaoFiscalLoading">
                    <i class="fa fa-refresh mr-1"></i> Atualizar
                  </b-button>
                  <b-button v-if="podeGerarNfePropria" variant="warning" size="sm" @click="gerarNfePropria(false)">
                    <i class="fa fa-file-text-o mr-1"></i> Gerar NF-e propria
                  </b-button>
                </div>
              </div>

              <div v-if="decisaoFiscal" class="alert border-0 shadow-xs" :class="classeDecisaoFiscal">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <strong>{{ decisaoFiscal.situacao }}</strong>
                    <div>{{ decisaoFiscal.mensagem }}</div>
                    <div v-if="decisaoFiscal.bloqueios && decisaoFiscal.bloqueios.length" class="mt-2 small">
                      <div v-for="bloqueio in decisaoFiscal.bloqueios" :key="bloqueio">
                        <i class="fa fa-lock mr-1"></i>{{ bloqueio }}
                      </div>
                    </div>
                  </div>
                  <b-badge :variant="decisaoFiscal.podeFinalizar ? 'success' : 'warning'" pill class="px-3 py-2">
                    {{ decisaoFiscal.podeFinalizar ? 'PRONTA PARA FINALIZAR' : 'PENDENTE' }}
                  </b-badge>
                </div>
              </div>

              <div v-if="nfePropriaPendente" class="alert alert-warning border-0 shadow-xs">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <strong>NF-e PROPRIA PENDENTE</strong>
                    <div>
                      A NF-e {{ devolucao.NFE_DEVOLUCAO_NUMERO || devolucao.NFE_DEVOLUCAO_ID }} ja foi criada na TB_NFE,
                      mas ainda nao esta autorizada. Trate a nota na tela de NF-e ou clique em Recalcular e Transmitir para tentar novamente.
                    </div>
                    <small class="text-muted">
                      Status: {{ nfeDevolucaoStatus || 'em digitacao' }} {{ devolucao.NFE_DEVOLUCAO_SITUACAO || '' }}
                    </small>
                  </div>
                  <div class="d-flex flex-wrap justify-content-end">
                    <b-button size="sm" variant="warning" class="mr-2 mb-1" :disabled="isBusy" @click="gerarNfePropria(true)">
                      <i class="fa fa-refresh mr-1"></i> Recalcular e Transmitir
                    </b-button>
                    <b-button size="sm" variant="outline-warning" class="mr-2 mb-1" :disabled="isBusy" @click="transmitirNfePropria()">
                      <i class="fa fa-paper-plane-o mr-1"></i> Apenas Transmitir
                    </b-button>
                    <b-button size="sm" variant="outline-warning" class="mb-1" @click="abrirNfePropria()">
                      <i class="fa fa-external-link mr-1"></i> Abrir NF-e
                    </b-button>
                  </div>
                </div>
              </div>

              <div v-if="finalizacaoResumo" class="alert border-0 shadow-xs" :class="classeFinalizacao">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <strong>FINALIZACAO OPERACIONAL</strong>
                    <div>{{ finalizacaoResumo.apto ? 'Venda, estoque e financeiro estao aptos para a finalizacao selecionada.' : 'Existem pendencias antes de concluir a devolucao.' }}</div>
                    <div v-if="finalizacaoResumo.bloqueios && finalizacaoResumo.bloqueios.length" class="mt-2 small">
                      <div v-for="bloqueio in finalizacaoResumo.bloqueios" :key="bloqueio">
                        <i class="fa fa-lock mr-1"></i>{{ bloqueio }}
                      </div>
                    </div>
                    <div v-if="finalizacaoResumo.avisos && finalizacaoResumo.avisos.length" class="mt-2 small">
                      <div v-for="aviso in finalizacaoResumo.avisos" :key="aviso">
                        <i class="fa fa-info-circle mr-1"></i>{{ aviso }}
                      </div>
                    </div>
                  </div>
                  <b-badge :variant="finalizacaoResumo.apto ? 'success' : 'danger'" pill class="px-3 py-2">
                    {{ finalizacaoResumo.apto ? 'APTA' : 'BLOQUEADA' }}
                  </b-badge>
                </div>
              </div>

              <b-row v-if="decisaoFiscal" class="mb-3">
                <b-col md="3">
                  <div class="decision-metric">
                    <small>Qtd. NF-e</small>
                    <strong>{{ formatarQuantidade(decisaoFiscal.totais.quantidadeDeclarada, 3) }}</strong>
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="decision-metric">
                    <small>Qtd. Conferida</small>
                    <strong>{{ formatarQuantidade(decisaoFiscal.totais.quantidadeConferida, 3) }}</strong>
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="decision-metric">
                    <small>Valor Aceito</small>
                    <strong>{{ formatarMoeda(decisaoFiscal.totais.valorAceito) }}</strong>
                  </div>
                </b-col>
                <b-col md="3">
                  <div class="decision-metric">
                    <small>Divergencias</small>
                    <strong>{{ decisaoFiscal.totais.divergencias }}</strong>
                  </div>
                </b-col>
              </b-row>

              <b-table
                v-if="decisaoFiscal"
                hover
                small
                responsive
                :items="decisaoFiscal.itens"
                :fields="decisaoFiscalFields"
                class="modern-premium-table"
              >
                <template #cell(PRODUTO_NOME)="data">
                  <span :class="data.item.DIVERGENTE_NFE ? 'text-warning font-weight-bold' : ''">{{ data.value }}</span>
                </template>
                <template #cell(QUANT_ORIGINAL)="data">
                  {{ formatarQuantidade(data.value, 3) }}
                  <small class="text-muted d-block">Pcs {{ data.item.PECAS_ORIGINAL || 0 }}</small>
                </template>
                <template #cell(QUANT_DEVOLVIDO_NFE)="data">
                  {{ formatarQuantidade(data.value, 3) }}
                  <small class="text-muted d-block">Pcs {{ data.item.PECAS_DEVOLVIDO_NFE || 0 }}</small>
                </template>
                <template #cell(QUANT_RECEPCAO)="data">
                  {{ formatarQuantidade(data.value, 3) }}
                  <small class="text-muted d-block">Pcs {{ data.item.PECAS_RECEPCAO || 0 }}</small>
                </template>
                <template #cell(DIFERENCA_QUANT)="data">
                  <span :class="data.item.DIVERGENTE_NFE ? 'text-warning font-weight-bold' : 'text-muted'">
                    {{ formatarQuantidade(data.value, 3) }}
                  </span>
                  <small class="text-muted d-block">Pcs {{ data.item.DIFERENCA_PECAS || 0 }}</small>
                </template>
                <template #cell(VALOR_ACEITO)="data">
                  <strong>{{ formatarMoeda(data.value) }}</strong>
                </template>
              </b-table>

              <div v-else class="text-center p-5 bg-light rounded border">
                <i class="fa fa-refresh fa-3x text-muted mb-3"></i>
                <p class="mb-0 text-muted">Atualize a decisao fiscal para ver o comparativo.</p>
              </div>
            </div>
          </b-tab>

          <!-- Aba Financeiro -->
          <b-tab title="Financeiro">
            <template #title>
              <i class="fa fa-money mr-2"></i> Financeiro
            </template>
            
            <div v-if="false" class="alert alert-info border-0 shadow-xs mb-4">
              <i class="fa fa-info-circle mr-2"></i> Os lançamentos financeiros de devolução serão registrados na tabela <strong>RECEBCAN</strong> após a finalização da conferência.
            </div>

            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="font-weight-bold mb-0">Titulos do contas a receber e rateio do desconto</h6>
              <b-button
                v-if="podeAtualizarFinanceiro"
                variant="success"
                size="sm"
                class="font-weight-bold"
                @click="atualizarFinanceiro()"
                :disabled="finalizacaoLoading || isBusy || financeiroAtualizando"
              >
                <i class="fa mr-1" :class="financeiroAtualizando ? 'fa-spinner fa-spin' : 'fa-money'"></i> Atualizar financeiro
              </b-button>
            </div>

            <div class="alert border-0 shadow-xs mb-4" :class="financeiroAtualizado ? 'alert-success' : 'alert-info'">
              <i class="fa fa-info-circle mr-2"></i>
              <span v-if="financeiroAtualizado">
                Financeiro atualizado com ajuste direto proporcional de {{ formatarMoeda(devolucao.VALOR_FINANCEIRO_DESCONTO || 0) }}. Esta etapa nao pode ser desfeita pela devolucao.
              </span>
              <span v-else>
                A finalizacao exige o ajuste direto dos titulos do Contas a Receber. Confirme os valores e use <strong>Atualizar financeiro</strong> antes de concluir.
              </span>
            </div>

            <div v-if="finalizacaoResumo && finalizacaoResumo.financeiro" class="row mb-3">
              <div class="col-md-3">
                <div class="finance-metric">
                  <small>Valor devolucao</small>
                  <strong>{{ formatarMoeda(finalizacaoResumo.financeiro.valorAceito || 0) }}</strong>
                </div>
              </div>
              <div class="col-md-3">
                <div class="finance-metric">
                  <small>Saldo titulos</small>
                  <strong>{{ formatarMoeda(finalizacaoResumo.financeiro.totalAberto || 0) }}</strong>
                </div>
              </div>
              <div class="col-md-3">
                <div class="finance-metric">
                  <small>Desconto rateado</small>
                  <strong>{{ formatarMoeda(finalizacaoResumo.financeiro.valorRateio || 0) }}</strong>
                </div>
              </div>
              <div class="col-md-3">
                <div class="finance-metric">
                  <small>Situacao</small>
                  <strong>{{ finalizacaoResumo.financeiro.situacao || '-' }}</strong>
                </div>
              </div>
            </div>

            <h6 class="font-weight-bold mb-3">Títulos de Crédito Gerados</h6>
            <div class="alert alert-info border-0 shadow-xs mb-4">
              <i class="fa fa-info-circle mr-2"></i> O desconto e rateado com duas casas decimais entre as parcelas sem boleto; qualquer resto fica na ultima parcela.
            </div>

            <b-table
              striped
              hover
              small
              responsive
              show-empty
              empty-text="Nenhum título gerado até o momento."
              :items="titulosFinanceiros"
              :fields="financeiroFieldsFinalizacao"
              class="modern-premium-table"
            >
              <template #cell(VALOR)="data">
                {{ formatarMoeda(data.value) }}
              </template>
              <template #cell(VL_DOC)="data">
                {{ formatarMoeda(data.value) }}
              </template>
              <template #cell(VL_ARECEBER)="data">
                {{ formatarMoeda(data.value) }}
              </template>
              <template #cell(DESCONTO_DEVOLUCAO)="data">
                <strong :class="(Number(data.value) || 0) > 0 ? 'text-success' : 'text-muted'">{{ formatarMoeda(data.value || 0) }}</strong>
              </template>
              <template #cell(VL_ARECEBER_NOVO)="data">
                {{ formatarMoeda(data.value || 0) }}
              </template>
              <template #cell(SITUACAO)="data">
                <b-badge :variant="variantSituacaoFinanceiro(data.value)">{{ data.value }}</b-badge>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </div>

      <!-- Footer Observation -->
      <b-card class="mt-4 border-0 shadow-sm">
        <label class="font-weight-bold text-muted small"><i class="fa fa-commenting-o mr-2"></i>Observações da Devolução</label>
        <b-form-textarea
          v-model="devolucao.OBSERVACAO_DEVOLUCAO"
          placeholder="Descreva o motivo da devolução ou observações relevantes para o financeiro..."
          rows="3"
          class="rounded-lg shadow-xs"
        />
      </b-card>
    </div>

    <!-- Modais -->
    <PesquisaVendasDevolucaoModal 
      id="modal-pesquisa-vendas-devolucao"
      @selecionado="onVendaSelecionada"
    />

    <PesquisaNfeDistribuicaoModal
      id="modal-pesquisa-nfe-distribuicao"
      @selecionado="onNfeSelecionada"
    />

    <!-- Modal de Diagnóstico Fiscal (Preflight) -->
    <b-modal
      id="modal-diagnostico-fiscal"
      title="DIAGNÓSTICO FISCAL (PREFLIGHT)"
      hide-footer
      centered
      size="lg"
      header-bg-variant="danger"
      header-text-variant="white"
    >
      <div v-if="diagnosticoPreflight">
        <div class="alert alert-danger border-0 mb-3 font-weight-bold">
          <i class="fa fa-times-circle mr-2"></i>
          A NF-e de devolução possui pendências fiscais impeditivas e a transmissão foi bloqueada.
        </div>
        
        <h6 class="font-weight-bold mb-2"><i class="fa fa-list-ul mr-2 text-danger"></i>Pendências Identificadas:</h6>
        <div class="list-group mb-4 shadow-sm">
          <div 
            v-for="(pendencia, index) in diagnosticoPreflight.pendencias" 
            :key="index"
            class="list-group-item list-group-item-action d-flex align-items-start gap-2 border-left-0 border-right-0"
            :class="pendencia.nivel === 'ERRO' ? 'border-left-danger' : 'border-left-warning'"
            style="border-left-width: 4px !important;"
          >
            <div class="mr-2">
              <i :class="pendencia.nivel === 'ERRO' ? 'fa fa-times-circle text-danger' : 'fa fa-exclamation-triangle text-warning'"></i>
            </div>
            <div>
              <div class="font-weight-bold text-dark mb-1">
                {{ pendencia.codigo }}
                <b-badge :variant="pendencia.nivel === 'ERRO' ? 'danger' : 'warning'" pill class="ml-2">{{ pendencia.nivel }}</b-badge>
              </div>
              <small class="text-muted">{{ pendencia.mensagem }}</small>
            </div>
          </div>
        </div>

        <div class="text-right">
          <b-button variant="secondary" @click="$bvModal.hide('modal-diagnostico-fiscal')">FECHAR</b-button>
        </div>
      </div>
    </b-modal>

    <b-overlay :show="isBusy" no-wrap fixed z-index="9999"></b-overlay>
  </div>
</template>

<script>
import HeaderPadrao from '../../../components/Cec/HeaderPadrao.vue'
import PesquisaVendasDevolucaoModal from './PesquisaVendasDevolucaoModal.vue'
import PesquisaNfeDistribuicaoModal from './PesquisaNfeDistribuicaoModal.vue'
import Tools from '@/tools/tools.js'
import VueAutonumeric from 'vue-autonumeric'
import CentroEstoqueDropDown from '../../componentes/dropdown/CentroEstoqueDropDown.vue'
import TipoMovimentacaoDropDown from '../../componentes/dropdown/TipoMovimentacaoDropDown.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'

export default {
  name: 'DevolucaoFaturamentoCadastro',
  components: {
    HeaderPadrao,
    PesquisaVendasDevolucaoModal,
    PesquisaNfeDistribuicaoModal,
    VueAutonumeric,
    CentroEstoqueDropDown,
    TipoMovimentacaoDropDown,
    ClientePesquisa
  },
  data() {
    return {
      isBusy: false,
      devolucao: {
        ID: null,
        FORNECEDOR_ID: null,
        DESTINATARIO_ID: null,
        CLIENTE_NOME: '',
        VENDA_ID: null,
        DATA_VENDA: null,
        VALOR_VENDA: 0,
        VALOR_DEVOLUCAO_NFE: 0,
        VALOR_REPROCESSADO: 0,
        STATUS: '1',
        OP_TIPO_MOVIMENTO: '3',
        OP_XML: '0',
        OP_CONFIRMAR_NFE: '0',
        OP_SOLICITA_RECEPCAO: '0',
        OP_RECEPCAO: '0',
        OP_NFE_PROPRIA: '0',
        OP_FINANCEIRO_ATUALIZADO: '0',
        VALOR_FINANCEIRO_DESCONTO: 0,
        CENTRO_ESTOQUE_ID: null,
        CHAVE_ACESSO_NFE_DEVOLVIDA: '',
        OBSERVACAO_DEVOLUCAO: '',
        itens: []
      },
      xmlChaveAcesso: '',
      decisaoFiscal: null,
      decisaoFiscalLoading: false,
      tipoMovimentacaoNfeId: null,
      diagnosticoPreflight: null,
      finalizacaoResumo: null,
      finalizacaoLoading: false,
      financeiroAtualizando: false,
      titulosFinanceiros: [],
      conferenciaLoading: false,
      conferenciaResumo: {
        devolucao: null,
        itens: [],
        etiquetas: []
      },
      opTipoMovimentoOptions: [
        { value: '1', text: 'Alterar pre-fatura/venda' },
        { value: '2', text: 'Alterar contas a receber' },
        { value: '3', text: 'Alterar pre-fatura e contas a receber' }
      ],
      itemFields: [
        { key: 'PRODUTO_ID', label: 'Cód.', sortable: true, thClass: 'text-center', tdClass: 'text-center bg-light-soft font-weight-bold', width: '80px' },
        { key: 'PRODUTO_NOME', label: 'Descrição do Produto', sortable: true, thClass: 'text-left' },
        { key: 'QUANT', label: 'Qtd. Devolvida', thClass: 'text-right', tdClass: 'text-right text-muted font-italic' },
        { key: 'PECAS', label: 'Vol. Devolvidos', thClass: 'text-right', tdClass: 'text-right text-muted font-italic' },
        { key: 'VL_UNT', label: 'Vl. Unit.', thClass: 'text-right', tdClass: 'text-right text-muted font-italic' },
        { key: 'QUANT_DEVOLVIDO_NFE', label: 'Qtd. Devolução', thClass: 'text-center', tdClass: 'text-center', width: '130px' },
        { key: 'PECAS_DEVOLVIDO_NFE', label: 'Pcs. Devolução', thClass: 'text-center', tdClass: 'text-center', width: '110px' },
        { key: 'VL_UNT_DEVOLVIDO', label: 'Vl. Devolvido', thClass: 'text-center', tdClass: 'text-center', width: '130px' },
        { key: 'TOTAL_ITEM', label: 'Total Item', thClass: 'text-right', tdClass: 'text-right font-weight-bold' }
      ],
      etiquetaColetadaFields: [
        { key: 'SEQUENCIA_EMBARQUE', label: 'Seq.', thClass: 'text-center', tdClass: 'text-center', width: '70px' },
        { key: 'CODIGO_BARRAS', label: 'Etiqueta / Produto' },
        { key: 'PESO', label: 'Peso', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'PECAS', label: 'Pecas', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'DATA_MOVIMENTO', label: 'Coleta' },
        { key: 'USUARIO_CADASTRO', label: 'Usuario' }
      ],
      financeiroFields: [
        { key: 'ID', label: 'ID' },
        { key: 'DATA', label: 'Data', formatter: v => v ? Tools.formatarDataBR(v) : '' },
        { key: 'VALOR', label: 'Valor', tdClass: 'text-right' },
        { key: 'SITUACAO', label: 'Situação' }
      ],
      decisaoFiscalFields: [
        { key: 'PRODUTO_ID', label: 'Cod.', thClass: 'text-center', tdClass: 'text-center font-weight-bold', width: '80px' },
        { key: 'PRODUTO_NOME', label: 'Produto', thClass: 'text-left' },
        { key: 'QUANT_ORIGINAL', label: 'Original', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'QUANT_DEVOLVIDO_NFE', label: 'NF-e Devolucao', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'QUANT_RECEPCAO', label: 'Conferencia', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'DIFERENCA_QUANT', label: 'Diferenca', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'VALOR_ACEITO', label: 'Valor Aceito', thClass: 'text-right', tdClass: 'text-right' }
      ],
      formatoMoeda: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        currencySymbol: 'R$ ',
        currencySymbolPlacement: 'p',
        roundingMethod: 'U',
        minimumValue: '0'
      },
      formatoQuantidade: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: 3,
        roundingMethod: 'U',
        minimumValue: '0'
      },
      formatoPecas: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: 0,
        roundingMethod: 'U',
        minimumValue: '0'
      }
    }
  },
  computed: {
    isDark() {
      return this.$store.state.isDark
    },
    podeGravar() {
      return this.devolucao.VENDA_ID && !this.edicaoDadosBloqueada
    },
    podeSolicitarConferencia() {
      return this.devolucao.ID &&
        this.devolucao.STATUS === '1' &&
        !this.edicaoDadosBloqueada &&
        this.devolucao.itens &&
        this.devolucao.itens.some(item =>
          (Number(item.QUANT_DEVOLVIDO_NFE) || 0) > 0 ||
          (Number(item.PECAS_DEVOLVIDO_NFE) || 0) > 0
        )
    },
    podeCancelarSolicitacaoConferencia() {
      return this.devolucao.ID &&
        ['2', '3'].includes(String(this.devolucao.STATUS || '')) &&
        !this.possuiEtiquetasColetadas &&
        !this.financeiroAtualizado
    },
    possuiVinculoFiscal() {
      return String(this.devolucao.OP_XML || '0') === '1' ||
        String(this.devolucao.OP_CONFIRMAR_NFE || '0') === '1' ||
        !!this.devolucao.NFE_DISTRIBUICAO_ID ||
        !!this.devolucao.NFE_DEVOLUCAO_ID ||
        String(this.devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA || '').replace(/\D/g, '').length === 44
    },
    financeiroAtualizado() {
      const financeiroResumo = this.finalizacaoResumo && this.finalizacaoResumo.financeiro
      return String(this.devolucao.OP_FINANCEIRO_ATUALIZADO || '0') === '1' ||
        (Number(this.devolucao.VALOR_FINANCEIRO_DESCONTO) || 0) > 0 ||
        !!(financeiroResumo && financeiroResumo.financeiroAtualizado)
    },
    podeCancelarDevolucao() {
      return this.devolucao.ID &&
        String(this.devolucao.STATUS || '') === '1' &&
        !this.possuiEtiquetasColetadas &&
        !this.possuiVinculoFiscal &&
        !this.financeiroAtualizado
    },
    podeDevolverTerminal() {
      return this.devolucao.ID && String(this.devolucao.STATUS) === '4' && String(this.devolucao.OP_RECEPCAO || '') === '3' && !this.financeiroAtualizado
    },
    possuiEtiquetasColetadas() {
      return this.etiquetasColetadas.length > 0
    },
    edicaoDadosBloqueada() {
      return !!this.devolucao.ID && (String(this.devolucao.STATUS) !== '1' || this.possuiEtiquetasColetadas || this.financeiroAtualizado)
    },
    centroEstoqueBloqueado() {
      return String(this.devolucao.STATUS || '') === '5'
    },
    etiquetasColetadas() {
      return (this.conferenciaResumo.etiquetas || [])
        .filter(item => String(item.OP_COLETADA || '0') === '1' || !!item.ETIQUETA_MOVIMENTO_DEVOLUCAO_ID)
        .sort((a, b) => (Number(a.SEQUENCIA_EMBARQUE) || 0) - (Number(b.SEQUENCIA_EMBARQUE) || 0))
    },
    totalEtiquetasColetadas() {
      return this.etiquetasColetadas.length
    },
    totalVolumesDevolucao() {
      return (this.devolucao.itens || []).reduce((acc, item) => acc + (Number(item.PECAS_DEVOLVIDO_NFE) || 0), 0)
    },
    totalPesoConferido() {
      return this.etiquetasColetadas.reduce((acc, item) => acc + (Number(item.PESO) || 0), 0)
    },
    conferenciaStatusLabel() {
      const status = String(this.devolucao.STATUS || '')
      const recepcao = String(this.devolucao.OP_RECEPCAO || '0')
      if (status === '5') return 'Finalizada'
      if (status === '4' || recepcao === '3') return 'Conferencia concluida'
      if (status === '3' || recepcao === '2') return 'Em conferencia'
      if (status === '2' || recepcao === '1') return 'Aguardando terminal'
      return 'Nao solicitada'
    },
    conferenciaStatusVariant() {
      const status = String(this.devolucao.STATUS || '')
      const recepcao = String(this.devolucao.OP_RECEPCAO || '0')
      if (status === '5') return 'dark'
      if (status === '4' || recepcao === '3') return 'success'
      if (status === '3' || recepcao === '2') return 'primary'
      if (status === '2' || recepcao === '1') return 'warning'
      return 'secondary'
    },
    conferenciaMensagem() {
      if (this.totalEtiquetasColetadas > 0) {
        return `${this.totalEtiquetasColetadas} etiqueta(s) coletada(s), ${this.formatarQuantidade(this.totalPesoConferido, 3)} kg conferidos.`
      }
      if (this.totalVolumesDevolucao > 0) return 'Volumes informados, aguardando bipagem no terminal.'
      return 'Sem volumes informados para conferencia por etiqueta.'
    },
    possuiNfeCliente() {
      return String(this.devolucao.OP_XML || '0') === '1' ||
        !!this.devolucao.NFE_DISTRIBUICAO_ID ||
        String(this.devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA || '').replace(/\D/g, '').length === 44
    },
    nfeClienteConciliada() {
      return String(this.devolucao.OP_XML || '0') === '1'
    },
    nfePropriaGerada() {
      return String(this.devolucao.OP_NFE_PROPRIA || '0') === '1' || !!this.devolucao.NFE_DEVOLUCAO_ID
    },
    nfeDevolucaoStatus() {
      return String(this.devolucao.NFE_DEVOLUCAO_STATUS || '').trim()
    },
    nfePropriaAutorizada() {
      return this.nfeDevolucaoStatus === '2'
    },
    tipoMovimentacaoNfeBloqueado() {
      return this.nfePropriaAutorizada || String(this.devolucao.STATUS || '') === '5'
    },
    nfePropriaPendente() {
      return this.nfePropriaGerada && !this.nfePropriaAutorizada && !this.nfeClienteConciliada
    },
    alteraFinanceiro() {
      return true
    },
    fluxoBadges() {
      const status = String(this.devolucao.STATUS || '1')
      const finalizada = status === '5'
      const qtItensXml = Number(this.devolucao.NFE_DISTRIBUICAO_QT_ITENS) || 0
      const nfeAutorizada = this.nfePropriaAutorizada
      const nfeGerada = this.nfePropriaGerada
      const temChave = String(this.devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA || '').replace(/\D/g, '').length === 44
      const temXmlCliente = this.possuiNfeCliente
      const manifestacaoRegistrada = String(this.devolucao.OP_CONFIRMAR_NFE || '0') === '1'
      const cienciaRegistrada = manifestacaoRegistrada ||
        String(this.devolucao.NFE_DISTRIBUICAO_OP_CIENCIA || '0') === '1'

      const etapaCadastro = {
        key: 'cadastro',
        icon: this.edicaoDadosBloqueada ? 'fa fa-lock' : 'fa fa-pencil',
        titulo: 'Cadastro',
        status: finalizada ? 'Concluido' : (this.edicaoDadosBloqueada ? 'Bloqueado' : 'Aberto'),
        variant: finalizada ? 'success' : (this.edicaoDadosBloqueada ? 'warning' : 'success'),
        descricao: finalizada
          ? 'Cadastro encerrado com a devolucao finalizada.'
          : (this.edicaoDadosBloqueada
          ? 'Dados protegidos porque o fluxo ja avancou para conferencia.'
          : 'Itens, valores e XML ainda podem ser ajustados.')
      }

      const etapaXml = {
        key: 'xml',
        icon: 'fa fa-file-code-o',
        titulo: 'XML / DTE',
        status: String(this.devolucao.OP_XML || '0') === '1' ? 'Conciliado' : (this.devolucao.NFE_DISTRIBUICAO_ID ? 'Vinculado' : (temChave ? 'Chave informada' : (finalizada && nfeGerada ? 'Nao aplicado' : 'Pendente'))),
        variant: String(this.devolucao.OP_XML || '0') === '1' ? 'success' : (this.devolucao.NFE_DISTRIBUICAO_ID ? 'info' : (temChave ? 'warning' : (finalizada && nfeGerada ? 'info' : 'secondary'))),
        descricao: finalizada && nfeGerada && !temXmlCliente
          ? 'Fluxo encerrado com NF-e propria, sem XML/DTE do cliente.'
          : (this.devolucao.NFE_DISTRIBUICAO_ID
          ? `${qtItensXml} item(ns) localizado(s) em TB_NFE_DISTRIBUICAO.`
          : 'NF-e do cliente ainda nao foi vinculada/conciliada.')
      }

      const etapaCiencia = {
        key: 'ciencia',
        icon: 'fa fa-bell-o',
        titulo: 'SEFAZ',
        status: manifestacaoRegistrada
          ? 'Manifestada'
          : (cienciaRegistrada ? 'Ciencia' : (this.possuiNfeCliente ? 'Pendente' : 'Nao aplicavel')),
        variant: manifestacaoRegistrada
          ? 'success'
          : (cienciaRegistrada ? 'info' : (this.possuiNfeCliente ? 'warning' : 'secondary')),
        descricao: this.possuiNfeCliente
          ? 'Manifestacao de confirmacao e obrigatoria quando ha NF-e do cliente.'
          : (finalizada && nfeGerada ? 'Manifestacao dispensada no fluxo com NF-e propria.' : 'Cliente sem NF-e de devolucao vinculada.')
      }

      const etapaConferencia = {
        key: 'conferencia',
        icon: 'fa fa-barcode',
        titulo: 'Conferencia',
        status: this.conferenciaStatusLabel,
        variant: this.conferenciaStatusVariant,
        descricao: this.conferenciaMensagem
      }

      const etapaFiscal = {
        key: 'fiscal',
        icon: 'fa fa-balance-scale',
        titulo: 'Decisao Fiscal',
        status: finalizada
          ? 'Concluida'
          : (this.decisaoFiscal
          ? (this.decisaoFiscal.podeFinalizar ? 'Liberada' : 'Pendente')
          : (['4', '5'].includes(status) ? 'Atualizar' : 'Aguardando')),
        variant: finalizada
          ? 'success'
          : (this.decisaoFiscal
          ? (this.decisaoFiscal.podeFinalizar ? 'success' : 'warning')
          : (['4', '5'].includes(status) ? 'info' : 'secondary')),
        descricao: this.decisaoFiscal
          ? this.decisaoFiscal.mensagem
          : (finalizada ? 'Decisao fiscal concluida.' : 'Conclua a conferencia para liberar a analise fiscal.')
      }

      const etapaNfe = {
        key: 'nfe',
        icon: 'fa fa-file-text-o',
        titulo: 'NF-e Devolucao',
        status: this.nfeClienteConciliada
          ? 'Cliente'
          : (this.possuiNfeCliente ? 'Conciliar' : (nfeGerada ? (nfeAutorizada ? 'Autorizada' : 'Gerada') : (this.decisaoFiscal && this.decisaoFiscal.podeFinalizar ? 'Opcional' : 'Aguardando'))),
        variant: this.nfeClienteConciliada
          ? 'success'
          : (this.possuiNfeCliente ? 'warning' : (nfeGerada ? (nfeAutorizada ? 'success' : 'warning') : (this.decisaoFiscal && this.decisaoFiscal.podeFinalizar ? 'info' : 'secondary'))),
        descricao: this.nfeClienteConciliada
          ? 'Existe NF-e do cliente vinculada/conciliada.'
          : (this.possuiNfeCliente ? 'NF-e do cliente baixada/vinculada precisa ser conciliada.' : (nfeGerada ? `NF-e propria ${this.devolucao.NFE_DEVOLUCAO_NUMERO || this.devolucao.NFE_DEVOLUCAO_ID || ''}. ${this.devolucao.NFE_DEVOLUCAO_SITUACAO || ''}`.trim() : 'NF-e propria e opcional quando nao ha NF-e do cliente baixada/conciliada.'))
      }

      const financeiro = this.finalizacaoResumo && this.finalizacaoResumo.financeiro
      const etapaFinanceiro = {
        key: 'financeiro',
        icon: 'fa fa-money',
        titulo: 'Financeiro',
        status: !this.alteraFinanceiro
          ? 'Sem alteracao'
          : (this.financeiroAtualizado ? 'Finalizado' : (financeiro ? ((financeiro.bloqueios && financeiro.bloqueios.length) ? 'Bloqueado' : 'Pendente') : 'Pendente')),
        variant: !this.alteraFinanceiro
          ? 'info'
          : (this.financeiroAtualizado ? 'success' : (financeiro ? ((financeiro.bloqueios && financeiro.bloqueios.length) ? 'danger' : 'warning') : 'warning')),
        descricao: !this.alteraFinanceiro
          ? 'Tipo de fechamento nao altera contas a receber.'
          : (this.financeiroAtualizado ? 'Ajuste direto de valores ja aplicado nos titulos.' : (financeiro ? ((financeiro.bloqueios && financeiro.bloqueios.length) ? 'Verifique a aba Financeiro e os bloqueios da finalizacao.' : 'Confirme o ajuste direto na aba Financeiro.') : 'Valide antes de concluir a devolucao.'))
      }

      const etapaFinalizacao = {
        key: 'finalizacao',
        icon: status === '5' ? 'fa fa-check-circle' : 'fa fa-flag-checkered',
        titulo: 'Finalizacao',
        status: status === '5' ? 'Concluida' : (this.podeConcluir ? 'Pronta' : 'Em andamento'),
        variant: status === '5' ? 'dark' : (this.podeConcluir ? 'success' : 'secondary'),
        descricao: status === '5'
          ? 'Devolucao finalizada.'
          : (this.podeConcluir ? 'Todos os controles obrigatorios estao liberados.' : 'Ainda existem etapas antes da conclusao.')
      }

      return [
        etapaCadastro,
        etapaXml,
        etapaCiencia,
        etapaConferencia,
        etapaFiscal,
        etapaNfe,
        etapaFinanceiro,
        etapaFinalizacao
      ]
    },
    podeConcluir() {
      return !!(this.decisaoFiscal && this.decisaoFiscal.podeFinalizar && this.finalizacaoResumo && this.finalizacaoResumo.apto)
    },
    podeGerarNfePropria() {
      return !!(this.decisaoFiscal && this.decisaoFiscal.podeGerarNfePropria)
    },
    podeAtualizarFinanceiro() {
      return !!(this.finalizacaoResumo &&
        this.finalizacaoResumo.financeiro &&
        this.finalizacaoResumo.financeiro.atualizacaoObrigatoria &&
        !this.finalizacaoResumo.financeiro.financeiroAtualizado &&
        !this.financeiroAtualizado)
    },
    classeDecisaoFiscal() {
      if (!this.decisaoFiscal) return 'alert-info'
      if (this.decisaoFiscal.tipo === 'success') return 'alert-success'
      if (this.decisaoFiscal.tipo === 'warning') return 'alert-warning'
      if (this.decisaoFiscal.tipo === 'danger') return 'alert-danger'
      return 'alert-info'
    },
    classeFinalizacao() {
      if (!this.finalizacaoResumo) return 'alert-info'
      return this.finalizacaoResumo.apto ? 'alert-success' : 'alert-danger'
    },
    financeiroFieldsFinalizacao() {
      return [
        { key: 'SEQUENCIA', label: 'Titulo' },
        { key: 'PARCELA', label: 'Parcela' },
        { key: 'DT_RECEB', label: 'Vencimento', formatter: v => v ? Tools.formatarDataBR(v) : '' },
        { key: 'VL_DOC', label: 'Valor original', tdClass: 'text-right' },
        { key: 'VL_ARECEBER', label: 'Valor aberto', tdClass: 'text-right' },
        { key: 'DESCONTO_DEVOLUCAO', label: 'Desconto devolucao', tdClass: 'text-right' },
        { key: 'VL_ARECEBER_NOVO', label: 'Saldo apos desconto', tdClass: 'text-right' },
        { key: 'SITUACAO', label: 'Situacao' }
      ]
    },
    saldoConciliar() {
      const valorVenda = Number(this.devolucao.VALOR_VENDA) || 0
      const valorDevolucao = Number(this.devolucao.VALOR_DEVOLUCAO_NFE) || 0
      const valorResidual = Number(this.devolucao.VALOR_REPROCESSADO) || 0
      return valorVenda - valorDevolucao - valorResidual
    }
  },
  methods: {
    formatarMoeda: Tools.formatCurrency,
    formatarData: Tools.formatarDataBR,
    formatarQuantidade: (v, p) => v ? v.toLocaleString('pt-BR', { minimumFractionDigits: p || 2, maximumFractionDigits: p || 2 }) : '0,00',
    loginUsuario() {
      return window.localStorage.getItem('login') ||
        this.$store.state.usuario.LOGIN ||
        this.$store.state.usuario.CPF ||
        this.$store.state.usuario.NOME
    },
    extrairErro(err) {
      const data = err && err.response && err.response.data
      if (data && typeof data === 'object') {
        return data.message || data.erro || data.mensagem || JSON.stringify(data)
      }
      return data || (err && err.message) || err
    },
    variantSituacaoFinanceiro(situacao) {
      const valor = String(situacao || '')
      if (['APTO', 'ATUALIZADO', 'RATEADO'].includes(valor)) return 'success'
      if (['AGUARDANDO_ATUALIZACAO', 'SEM_DESCONTO'].includes(valor)) return 'warning'
      if (valor === 'BLOQUEADO_BOLETO') return 'danger'
      return 'secondary'
    },
    carregar(idParam) {
      const id = idParam || this.$route.params.id
      if (id && id !== 'novo') {
        this.isBusy = true
        return this.$store.dispatch('devolucao/getDevolucaoById', id)
          .then(res => {
            this.devolucao = res
            this.devolucao.OP_TIPO_MOVIMENTO = '3'
            if (!this.devolucao.DESTINATARIO_ID) {
              this.devolucao.DESTINATARIO_ID = this.devolucao.FORNECEDOR_ID
            }
            if (res && res.NFE_DEVOLUCAO_TIPO_MOV_ID) {
              this.tipoMovimentacaoNfeId = res.NFE_DEVOLUCAO_TIPO_MOV_ID
            }
            this.decisaoFiscal = null
            this.finalizacaoResumo = null
            this.titulosFinanceiros = []
            this.carregarConferenciaResumo().catch(() => null)
            if (['4', '5'].includes(String(res.STATUS))) {
              this.carregarDecisaoFiscal()
            }
          })
          .finally(() => {
            this.isBusy = false
          })
      }
      return Promise.resolve(null)
    },
    carregarConferenciaResumo() {
      if (!this.devolucao.ID) {
        this.conferenciaResumo = { devolucao: null, itens: [], etiquetas: [] }
        return Promise.resolve(this.conferenciaResumo)
      }

      this.conferenciaLoading = true
      return this.$http.get(`/api/protected/devolucao/conferencia/itens/${this.devolucao.ID}`)
        .then(res => {
          this.conferenciaResumo = {
            devolucao: res.data.devolucao || null,
            itens: res.data.itens || [],
            etiquetas: res.data.etiquetas || []
          }
          return this.conferenciaResumo
        })
        .catch(err => {
          this.conferenciaResumo = { devolucao: null, itens: [], etiquetas: [] }
          throw err
        })
        .finally(() => {
          this.conferenciaLoading = false
        })
    },
    onVendaSelecionada(venda) {
      this.isBusy = true
      this.$store.dispatch('devolucao/vincularPreFatura', {
        vendaId: venda.SEQUENCIA,
        usuario: this.$store.state.usuario.NOME
      })
      .then(res => {
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Venda vinculada com sucesso!')
        this.$router.push(`/faturamento/devolucao/cadastro/${res.ID}`)
        this.carregar(res.ID)
      })
      .catch(err => {
        const data = err && err.response && err.response.data
        const mensagem = (data && data.message) || data || (err && err.message) || err
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', mensagem)
      })
      .finally(() => {
        this.isBusy = false
      })
    },
    salvar(msgSuccess = 'Devolução salva com sucesso!', voltarDepois = true, exibirErro = true) {
      // Validação Delphi: Precisa ter itens com quantidade devolvida
      const temItens = this.devolucao.itens.some(i =>
        (Number(i.QUANT_DEVOLVIDO_NFE) || 0) > 0 ||
        (Number(i.PECAS_DEVOLVIDO_NFE) || 0) > 0
      )
      if (!temItens) {
        return Tools.exibirMensagem(this.$store, 'Validação', 'warning', 'Informe a quantidade devolvida de pelo menos um item.')
      }

      // Recálculo de Totais (Business Logic Delphi)
      this.devolucao.VALOR_DEVOLUCAO_NFE = this.devolucao.itens.reduce((acc, item) => {
        return acc + ((Number(item.QUANT_DEVOLVIDO_NFE) || 0) * (Number(item.VL_UNT_DEVOLVIDO || item.VL_UNT) || 0))
      }, 0)
      
      this.devolucao.VALOR_REPROCESSADO = Math.max((Number(this.devolucao.VALOR_VENDA) || 0) - this.devolucao.VALOR_DEVOLUCAO_NFE, 0)

      this.isBusy = true
      this.devolucao.USUARIO_ALTERACAO = this.$store.state.usuario.NOME
      this.devolucao.OP_TIPO_MOVIMENTO = '3'
      return this.$store.dispatch('devolucao/salvarDevolucao', this.devolucao)
        .then(() => {
          if (msgSuccess) Tools.exibirMensagem(this.$store, 'Sucesso', 'success', msgSuccess)
          if (voltarDepois && this.devolucao.STATUS !== '5') {
             this.voltar()
          }
        })
        .catch(err => {
          if (exibirErro) {
            Tools.exibirMensagem(this.$store, 'Erro', 'danger', this.extrairErro(err))
          }
          throw err
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    async solicitarConferencia() {
      if (!this.devolucao.ID) return
      this.isBusy = true
      try {
        await this.salvar(null, false, false)
        this.isBusy = true
        await this.$store.dispatch('devolucao/solicitarConferencia', {
          devolucaoId: this.devolucao.ID,
          centroEstoqueId: this.devolucao.CENTRO_ESTOQUE_ID,
          usuario: this.$store.state.usuario.NOME
        })
        Tools.exibirMensagem(this.$store, 'Conferencia', 'success', 'Conferencia solicitada ao estoque.')
        this.carregar()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro ao solicitar conferencia', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
      }
    },
    async cancelarSolicitacaoConferencia() {
      if (!this.devolucao.ID) return
      const confirmar = await this.$bvModal.msgBoxConfirm(
        'Cancelar a solicitacao de conferencia e devolver a devolucao para cadastro?',
        {
          title: 'Cancelar conferencia',
          okTitle: 'SIM, CANCELAR',
          cancelTitle: 'VOLTAR',
          okVariant: 'warning',
          centered: true
        }
      )
      if (!confirmar) return

      this.isBusy = true
      try {
        const res = await this.$store.dispatch('devolucao/cancelarSolicitacaoConferencia', {
          devolucaoId: this.devolucao.ID,
          usuario: this.$store.state.usuario.NOME
        })
        Tools.exibirMensagem(this.$store, 'Conferencia', 'success', res.mensagem || 'Solicitacao cancelada.')
        this.carregar()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Conferencia', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
      }
    },
    async cancelarDevolucao() {
      if (!this.devolucao.ID) return
      const confirmar = await this.$bvModal.msgBoxConfirm(
        `Cancelar a devolucao #${this.devolucao.ID}? Use apenas quando a venda foi vinculada por engano e ainda nao existe XML, NF-e, conferencia ou financeiro atualizado.`,
        {
          title: 'Cancelar devolucao',
          okTitle: 'SIM, CANCELAR',
          cancelTitle: 'VOLTAR',
          okVariant: 'danger',
          centered: true
        }
      )
      if (!confirmar) return

      this.isBusy = true
      try {
        const res = await this.$store.dispatch('devolucao/cancelarDevolucao', {
          devolucaoId: this.devolucao.ID,
          usuario: this.$store.state.usuario.NOME
        })
        Tools.exibirMensagem(this.$store, 'Devolucao', 'success', res.mensagem || 'Devolucao cancelada.')
        this.voltar()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Devolucao', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
      }
    },
    async devolverTerminalConferencia() {
      if (!this.devolucao.ID) return

      const confirmar = await this.$bvModal.msgBoxConfirm(
        `Deseja devolver a devolucao #${this.devolucao.ID} ao terminal de conferencia? As etiquetas ja coletadas permanecem vinculadas e poderao ser corrigidas no terminal.`,
        {
          title: 'Devolver ao terminal',
          okTitle: 'SIM, DEVOLVER',
          cancelTitle: 'CANCELAR',
          okVariant: 'warning',
          centered: true
        }
      )
      if (!confirmar) return

      this.isBusy = true
      try {
        const res = await this.$store.dispatch('devolucao/devolverTerminalConferencia', {
          devolucaoId: this.devolucao.ID,
          usuario: this.$store.state.usuario.NOME
        })
        Tools.exibirMensagem(this.$store, 'Conferencia', 'success', res.mensagem || 'Devolucao reaberta para o terminal.')
        this.carregar()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Conferencia', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
      }
    },
    carregarDecisaoFiscal() {
      if (!this.devolucao.ID) return Promise.resolve(null)
      this.decisaoFiscalLoading = true
      return this.$store.dispatch('devolucao/validarDecisaoFiscal', {
        devolucaoId: this.devolucao.ID
      })
        .then(res => {
          this.decisaoFiscal = res
          if (res && res.nfeDevolucaoTipoMovimentacaoId && !this.tipoMovimentacaoNfeId) {
            this.tipoMovimentacaoNfeId = res.nfeDevolucaoTipoMovimentacaoId
          }
          if (res && res.podeFinalizar) {
            this.carregarFinalizacao().catch(() => null)
          } else {
            this.finalizacaoResumo = null
            this.titulosFinanceiros = []
          }
          return res
        })
        .catch(err => {
          Tools.exibirMensagem(this.$store, 'Decisao fiscal', 'danger', this.extrairErro(err))
          throw err
        })
        .finally(() => {
          this.decisaoFiscalLoading = false
        })
    },
    formatarChaveAcesso(chave) {
      if (!chave) return '-'
      const limpa = String(chave).replace(/\D/g, '')
      if (limpa.length !== 44) return chave
      return limpa.match(/.{1,4}/g).join(' ')
    },
    carregarFinalizacao() {
      if (!this.devolucao.ID) return Promise.resolve(null)
      this.finalizacaoLoading = true
      return this.$store.dispatch('devolucao/validarFinalizacao', {
        devolucaoId: this.devolucao.ID,
        centroEstoqueId: this.devolucao.CENTRO_ESTOQUE_ID,
        opTipoMovimento: '3',
        login: this.loginUsuario()
      })
        .then(res => {
          this.finalizacaoResumo = res
          this.titulosFinanceiros = res && res.financeiro
            ? ((res.financeiro.rateio && res.financeiro.rateio.length) ? res.financeiro.rateio : (res.financeiro.titulos || []))
            : []
          return res
        })
        .catch(err => {
          Tools.exibirMensagem(this.$store, 'Finalizacao', 'danger', this.extrairErro(err))
          throw err
        })
        .finally(() => {
        this.finalizacaoLoading = false
      })
    },
    onCentroEstoqueChange() {
      if (!this.devolucao.ID || !this.decisaoFiscal || !this.decisaoFiscal.podeFinalizar) return
      this.carregarFinalizacao().catch(() => null)
    },
    onDestinatarioChange(id) {
      this.devolucao.DESTINATARIO_ID = id || null
    },
    async atualizarFinanceiro() {
      if (!this.devolucao.ID) return
      if (this.financeiroAtualizando || this.isBusy || this.financeiroAtualizado) return

      this.financeiroAtualizando = true
      try {
        const resumo = this.finalizacaoResumo || await this.carregarFinalizacao()
        const financeiro = resumo && resumo.financeiro
        if (!financeiro || !financeiro.atualizacaoObrigatoria) return

        const confirmar = await this.$bvModal.msgBoxConfirm(
          `Aplicar o ajuste direto proporcional de ${this.formatarMoeda(financeiro.valorRateio || 0)} nos titulos do contas a receber? Esta etapa nao podera ser desfeita pela devolucao.`,
          {
            title: 'Atualizar financeiro',
            okTitle: 'SIM, ATUALIZAR',
            cancelTitle: 'VOLTAR',
            okVariant: 'success',
            centered: true
          }
        )
        if (!confirmar) return

        this.isBusy = true
        const res = await this.$store.dispatch('devolucao/atualizarFinanceiro', {
          devolucaoId: this.devolucao.ID,
          centroEstoqueId: this.devolucao.CENTRO_ESTOQUE_ID,
          opTipoMovimento: '3',
          usuario: this.$store.state.usuario.NOME
        })
        this.devolucao.OP_FINANCEIRO_ATUALIZADO = '1'
        this.devolucao.VALOR_FINANCEIRO_DESCONTO = res.valorDesconto || financeiro.valorRateio || this.devolucao.VALOR_FINANCEIRO_DESCONTO
        if (this.finalizacaoResumo && this.finalizacaoResumo.financeiro) {
          this.finalizacaoResumo.financeiro = {
            ...this.finalizacaoResumo.financeiro,
            apto: true,
            situacao: 'ATUALIZADO',
            financeiroAtualizado: true,
            atualizacaoObrigatoria: false,
            bloqueios: []
          }
        }
        Tools.exibirMensagem(this.$store, 'Financeiro', 'success', res.mensagem || 'Financeiro atualizado.')
        await this.carregar(this.devolucao.ID)
        await this.carregarDecisaoFiscal()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Financeiro', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
        this.financeiroAtualizando = false
      }
    },
    abrirNfePropria() {
      if (!this.devolucao.NFE_DEVOLUCAO_ID) return
      this.$router.push({ name: 'NFe - Cadastro', params: { id: this.devolucao.NFE_DEVOLUCAO_ID }, query: { acao: 'E' } })
    },
    async imprimirDanfeDevolucao() {
      if (!this.devolucao.NFE_DEVOLUCAO_ID) {
        return Tools.exibirMensagem(this.$store, 'DANFE', 'warning', 'NF-e propria da devolucao nao localizada.')
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        const response = await this.$http.post('/api/protected/notaFiscal/downloadPDF/', {
          nfeId: this.devolucao.NFE_DEVOLUCAO_ID,
          empresaId: this.devolucao.NFE_DEVOLUCAO_EMPRESA_ID || this.devolucao.EMPRESA_ID || this.$store.state.usuario.EMPRESA_ID || 1
        })
        const resultado = response.data

        if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
          throw new Error(resultado?.erro || resultado?.message || 'Nao foi possivel baixar o DANFE da NF-e de devolucao.')
        }

        this.abrirPdfBase64(resultado.pdfBase64)
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'DANFE', 'danger', this.extrairErro(err))
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    abrirPdfBase64(pdfBase64) {
      if (!pdfBase64) return
      const byteCharacters = atob(pdfBase64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      window.open(url)
    },
    async transmitirNfePropria() {
      if (!this.devolucao.NFE_DEVOLUCAO_ID) return

      const confirmar = await this.$bvModal.msgBoxConfirm(
        'Deseja transmitir a NF-e propria de devolucao pelo integrador?',
        {
          title: 'Transmitir NF-e propria',
          okTitle: 'SIM, TRANSMITIR',
          cancelTitle: 'VOLTAR',
          okVariant: 'warning',
          centered: true
        }
      )
      if (!confirmar) return

      this.isBusy = true
      try {
        const { data } = await this.$http.post('/api/protected/notaFiscal/processarIntegrador', {
          nfeId: this.devolucao.NFE_DEVOLUCAO_ID,
          usuario: window.localStorage.getItem('login') || this.$store.state.usuario.NOME,
          tela: 'N'
        })

        if (!data || !data.sucesso || !data.pdfBase64) {
          throw new Error(data?.erro || data?.message || 'Nao foi possivel transmitir a NF-e propria.')
        }

        this.abrirPdfBase64(data.pdfBase64)
        Tools.exibirMensagem(this.$store, 'NF-e propria', 'success', 'NF-e propria transmitida e autorizada.')
        await this.carregar(this.devolucao.ID)
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'NF-e propria', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
      }
    },
    async gerarNfePropria(isRecalculo = false) {
      if (!this.devolucao.ID) return
      if (!this.tipoMovimentacaoNfeId || Number(this.tipoMovimentacaoNfeId) <= 0) {
        return Tools.exibirMensagem(this.$store, 'NF-e propria', 'warning', 'Informe o tipo de movimentacao fiscal de devolucao.')
      }

      const confirmMsg = isRecalculo
        ? 'Deseja recalcular os impostos e retransmitir a NF-e propria de devolucao?'
        : 'Deseja gerar e transmitir a NF-e propria de devolucao com as quantidades conferidas?'

      const confirmar = await this.$bvModal.msgBoxConfirm(
        confirmMsg,
        {
          title: 'NF-e propria',
          okTitle: 'SIM, TRANSMITIR',
          cancelTitle: 'NAO',
          okVariant: 'warning',
          centered: true
        }
      )
      if (!confirmar) return

      this.isBusy = true
      this.diagnosticoPreflight = null
      
      try {
        // 1. Aciona a API de diagnóstico/preflight do motor fiscal
        const diag = await this.$store.dispatch('devolucao/diagnosticarDevolucao', {
          devolucaoId: this.devolucao.ID,
          empresaId: this.devolucao.EMPRESA_ID || this.$store.state.usuario.EMPRESA_ID || 1,
          tipoMovimentacaoId: this.tipoMovimentacaoNfeId,
          destinatarioId: this.devolucao.DESTINATARIO_ID,
          usuario: this.loginUsuario() || 'sistema'
        })

        if (!diag.sucesso) {
          throw new Error(diag.erro || 'Falha ao rodar preflight fiscal.')
        }

        // Se houver pendências fiscais impeditivas (nível ERRO), exibe o modal de diagnóstico e bloqueia
        if (diag.preflight && diag.preflight.ok === false) {
          const temErroImpeditivo = diag.preflight.pendencias && diag.preflight.pendencias.some(p => p.nivel === 'ERRO')
          if (temErroImpeditivo) {
            this.diagnosticoPreflight = diag.preflight
            this.$bvModal.show('modal-diagnostico-fiscal')
            this.isBusy = false
            return
          }
        }

        // 2. Se preflight estiver limpo (ou apenas com avisos), prosseguir com a gravação e transmissão
        const res = await this.$store.dispatch('devolucao/gerarNfePropria', {
          devolucaoId: this.devolucao.ID,
          empresaId: this.devolucao.EMPRESA_ID || this.$store.state.usuario.EMPRESA_ID || 1,
          tipoMovimentacaoId: this.tipoMovimentacaoNfeId,
          destinatarioId: this.devolucao.DESTINATARIO_ID,
          usuario: this.loginUsuario() || 'sistema'
        })

        if (res.pdfBase64) {
          this.abrirPdfBase64(res.pdfBase64)
        }
        Tools.exibirMensagem(this.$store, 'NF-e propria', res.transmitida ? 'success' : 'warning', res.mensagem || 'NF-e propria gerada.')
        await this.carregar(this.devolucao.ID)
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'NF-e propria', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
      }
    },
    async concluir() {
      if (!this.devolucao.ID) return
      try {
        const resumo = await this.carregarFinalizacao()

        if (!resumo || !resumo.apto) {
          Tools.exibirMensagem(this.$store, 'Finalizacao', 'warning', 'Existem pendencias antes de finalizar. Consulte a aba Decisao Fiscal.')
          return
        }

        const confirmar = await this.$bvModal.msgBoxConfirm(
          'Deseja finalizar a devolucao com os impactos selecionados?',
          {
            title: 'Finalizar devolucao',
            okTitle: 'SIM, FINALIZAR',
            cancelTitle: 'NAO',
            okVariant: 'warning',
            centered: true
          }
        )
        if (!confirmar) return
        if (!this.finalizacaoResumo || !this.finalizacaoResumo.apto) return
        this.isBusy = true
        const res = await this.$store.dispatch('devolucao/finalizar', {
          devolucaoId: this.devolucao.ID,
          centroEstoqueId: this.devolucao.CENTRO_ESTOQUE_ID,
          opTipoMovimento: '3',
          login: this.loginUsuario(),
          usuario: this.$store.state.usuario.NOME
        })
        Tools.exibirMensagem(this.$store, 'Finalizacao', 'success', res.mensagem || 'Devolucao finalizada com sucesso.')
        this.carregar()
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Finalizacao', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
      }
    },
    vincularXml() {
      if (this.edicaoDadosBloqueada) {
        return Tools.exibirMensagem(this.$store, 'XML', 'warning', 'Nao e possivel alterar XML ou itens apos a conferencia ter sido solicitada/coletada.')
      }
      this.$bvModal.show('modal-pesquisa-nfe-distribuicao')
    },
    async onNfeSelecionada(nfe) {
      if (!nfe.CHAVE_ACESSO || nfe.CHAVE_ACESSO.length !== 44) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Esta nota não possui uma chave de acesso válida.')
        return
      }

      this.isBusy = true
      try {
        const res = await this.$store.dispatch('devolucao/conciliarXml', {
          devolucaoId: this.devolucao.ID,
          chaveAcesso: nfe.CHAVE_ACESSO,
          nfeDistribuicaoId: nfe.ID,
          empresaId: this.$store.state.usuario.EMPRESA_ID || 1,
          usuario: this.$store.state.usuario.NOME
        })
        
        if (res.sucesso) {
          const tipo = res.divergencias && res.divergencias.length ? 'warning' : 'success'
          Tools.exibirMensagem(this.$store, 'XML', tipo, res.mensagem || 'XML conciliado com sucesso! Os itens foram atualizados.')
          this.carregar()
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
      }
    },
    voltar() {
      this.$router.push('/faturamento/devolucao/index')
    },
    consultarSefaz() {
      if (!this.devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA) return
      this.isBusy = true
      this.$store.dispatch('devolucao/baixarPorChave', {
        chaveAcesso: this.devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA,
        empresaId: this.devolucao.EMPRESA_ID || this.$store.state.usuario.EMPRESA_ID || 1,
        usuario: this.$store.state.usuario.NOME
      })
      .then(async res => {
        if (this.devolucao.ID && res && res.nfe && res.nfe.CHAVE_ACESSO && res.possuiItens) {
          const conciliacao = await this.$store.dispatch('devolucao/conciliarXml', {
            devolucaoId: this.devolucao.ID,
            chaveAcesso: res.nfe.CHAVE_ACESSO,
            nfeDistribuicaoId: res.nfe.ID,
            empresaId: this.devolucao.EMPRESA_ID || this.$store.state.usuario.EMPRESA_ID || 1,
            usuario: this.$store.state.usuario.NOME
          })
          Tools.exibirMensagem(this.$store, 'Consulta', conciliacao.divergencias && conciliacao.divergencias.length ? 'warning' : 'success', conciliacao.mensagem || 'NF-e baixada e conciliada com a devolucao.')
          await this.carregar(this.devolucao.ID)
          return
        }
        Tools.exibirMensagem(this.$store, 'Consulta', res.possuiItens ? 'success' : 'warning', res.possuiItens ? 'NF-e baixada com itens disponiveis para conciliacao.' : 'NF-e baixada, mas os itens ainda nao foram disponibilizados.')
      })
      .catch(err => Tools.exibirMensagem(this.$store, 'Erro na consulta', 'danger', this.extrairErro(err)))
      .finally(() => this.isBusy = false)
    },
    darCienciaSefaz() {
      if (!this.devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA) return
      this.isBusy = true
      this.$store.dispatch('devolucao/darCiencia', {
        chaveAcesso: this.devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA,
        empresaId: this.devolucao.EMPRESA_ID || this.$store.state.usuario.EMPRESA_ID || 1,
        usuario: this.$store.state.usuario.NOME
      })
      .then(() => {
        Tools.exibirMensagem(this.$store, 'Ciencia', 'success', 'Ciencia enviada com sucesso. Agora tente baixar a NF-e por chave.')
      })
      .catch(err => Tools.exibirMensagem(this.$store, 'Erro na ciencia', 'danger', this.extrairErro(err)))
      .finally(() => this.isBusy = false)
    },
    async manifestarSefaz() {
      if (!this.devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA) return
      const confirmar = await this.$bvModal.msgBoxConfirm(
        'Deseja manifestar a Confirmacao da Operacao para esta NFe?',
        {
          title: 'Confirmacao',
          okTitle: 'SIM, MANIFESTAR',
          cancelTitle: 'NAO',
          okVariant: 'warning',
          centered: true
        }
      )
      if (!confirmar) return

      this.isBusy = true
      try {
        await this.$store.dispatch('devolucao/manifestar', {
          chaveAcesso: this.devolucao.CHAVE_ACESSO_NFE_DEVOLVIDA,
          empresaId: this.devolucao.EMPRESA_ID || this.$store.state.usuario.EMPRESA_ID || 1,
          usuario: this.$store.state.usuario.NOME
        })
        Tools.exibirMensagem(this.$store, 'Manifestacao', 'success', 'Manifestacao enviada com sucesso!')
        this.devolucao.OP_CONFIRMAR_NFE = '1'
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro na manifestacao', 'danger', this.extrairErro(err))
      } finally {
        this.isBusy = false
      }
    },
    desvincularXml() {
      if (!this.devolucao.ID) return
      this.isBusy = true
      this.$store.dispatch('devolucao/desvincularXml', {
        devolucaoId: this.devolucao.ID,
        usuario: this.$store.state.usuario.NOME
      })
      .then(() => {
        Tools.exibirMensagem(this.$store, 'XML', 'success', 'XML desvinculado com sucesso.')
        this.carregar()
      })
      .catch(err => Tools.exibirMensagem(this.$store, 'Erro ao desvincular XML', 'danger', this.extrairErro(err)))
      .finally(() => this.isBusy = false)
    },
    baixarXmlSefaz() {
      this.consultarSefaz()
    }
  },
  mounted() {
    this.carregar()
  }
}
</script>

<style scoped>
.page-shell {
  padding: 1.5rem;
}

.custom-tabs-premium >>> .nav-item {
  margin-right: 0.5rem;
}

.custom-tabs-premium >>> .nav-link {
  border-radius: 10px 10px 0 0;
  padding: 0.75rem 1.5rem;
  color: #64748b;
  transition: all 0.2s;
}

.custom-tabs-premium >>> .nav-link.active {
  box-shadow: 0 -4px 10px rgba(0,0,0,0.05);
}

.bg-soft-info { background-color: rgba(32, 168, 216, 0.1); }
.bg-soft-success { background-color: rgba(77, 189, 116, 0.1); }
.bg-soft-primary { background-color: rgba(32, 168, 216, 0.1); }

.decision-metric {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 0.85rem 1rem;
  min-height: 76px;
}

.decision-metric small {
  color: #6c757d;
  display: block;
  font-weight: 700;
  text-transform: uppercase;
}

.decision-metric strong {
  color: #2f353a;
  display: block;
  font-size: 1.15rem;
  margin-top: 0.25rem;
}

.finance-metric {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  min-height: 72px;
  padding: 0.75rem 0.9rem;
}

.finance-metric small {
  color: #6c757d;
  display: block;
  font-weight: 700;
  text-transform: uppercase;
}

.finance-metric strong {
  color: #2f353a;
  display: block;
  font-size: 1rem;
  margin-top: 0.2rem;
}

.conference-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-left: 5px solid #0ea5e9;
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.conference-card__main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.conference-card__text strong {
  display: block;
  color: #0f172a;
}

.conference-card__text span {
  color: #64748b;
  font-size: 0.85rem;
}

.conference-card__metrics {
  display: flex;
  gap: 22px;
  text-align: right;
}

.conference-card__metrics small {
  display: block;
  color: #64748b;
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
}

.conference-card__metrics strong {
  display: block;
  color: #0f172a;
  font-size: 1.05rem;
}

.flow-board {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
  overflow: hidden;
}

.flow-step {
  min-height: 112px;
  padding: 14px;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  gap: 12px;
  background: #fff;
}

.flow-step:nth-child(4n) {
  border-right: 0;
}

.flow-step:nth-last-child(-n+4) {
  border-bottom: 0;
}

.flow-step__icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  background: #f1f5f9;
  color: #475569;
}

.flow-step__body {
  min-width: 0;
  flex: 1;
}

.flow-step__metrics {
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  font-size: 0.72rem;
  color: #64748b;
  margin-top: 8px;
  padding-top: 6px;
}
.flow-step__metrics span {
  white-space: nowrap;
}
.flow-step__metrics strong {
  color: #0f172a;
}

.flow-step__actions {
  margin-top: 8px;
}

.flow-step__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.flow-step__top strong {
  color: #0f172a;
  font-size: 0.88rem;
}

.flow-step__body small {
  color: #64748b;
  display: block;
  line-height: 1.25;
}

.flow-step--success .flow-step__icon { background: #dcfce7; color: #15803d; }
.flow-step--warning .flow-step__icon { background: #fef3c7; color: #b45309; }
.flow-step--danger .flow-step__icon { background: #fee2e2; color: #b91c1c; }
.flow-step--info .flow-step__icon { background: #e0f2fe; color: #0369a1; }
.flow-step--primary .flow-step__icon { background: #dbeafe; color: #1d4ed8; }
.flow-step--dark .flow-step__icon { background: #e5e7eb; color: #111827; }

.border-dashed {
  border-style: dashed !important;
  border-width: 2px !important;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 0.5rem 1.25rem;
  border-radius: 50px;
  font-weight: 600;
  transition: all 0.2s;
}

.btn-glass:hover {
  background: rgba(255, 255, 255, 0.25);
  color: white;
}

.uppercase { text-transform: uppercase; letter-spacing: 0.05em; }
.font-xs { font-size: 0.75rem; }
.gap-2 { gap: 0.5rem; }

@media (max-width: 992px) {
  .conference-card,
  .conference-card__metrics {
    align-items: stretch;
    flex-direction: column;
    text-align: left;
  }

  .flow-board {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .flow-step:nth-child(4n) {
    border-right: 1px solid #e2e8f0;
  }

  .flow-step:nth-child(2n) {
    border-right: 0;
  }

  .flow-step:nth-last-child(-n+4) {
    border-bottom: 1px solid #e2e8f0;
  }

  .flow-step:nth-last-child(-n+2) {
    border-bottom: 0;
  }
}

@media (max-width: 576px) {
  .flow-board {
    grid-template-columns: 1fr;
  }

  .flow-step,
  .flow-step:nth-child(2n),
  .flow-step:nth-child(4n) {
    border-right: 0;
  }

  .flow-step:nth-last-child(-n+2) {
    border-bottom: 1px solid #e2e8f0;
  }

  .flow-step:last-child {
    border-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/devolucao/DevolucaoFaturamentoCadastro.vue